<template>
  <div class="main">
    <div class="addView">
      <span style="font-size: 22px;color: #262626;font-weight: 600; margin-right: 16px;">{{ getYear() }}年</span>
      <el-autocomplete popper-class="my-autocomplete"
                       v-model="state"
                       :fetch-suggestions="querySearch"
                       placeholder="请输入"
                       @select="handleSelect"
                       size="small"
                       style="width: 200px;z-index: 99999;"
                       clearable>
        <template slot-scope="{ item }">
          <div class="name">{{ item.shopName }}</div>
        </template>
      </el-autocomplete>
      <div style="width: 16px;"></div>
      <el-date-picker v-model="timeSelect"
                      type="date"
                      style="width: 150px"
                      size="small"
                      placeholder="请选择日期"
                      :clearable="false">
      </el-date-picker>
      <div style="width: 16px;"></div>
      <el-select v-model="goodsType"
                 style="width: 150px"
                 size="small">
        <el-option label="消肿止痛贴"
                   value="消肿止痛贴" />
      </el-select>
      <div style="width: 16px;"></div>
      <el-input placeholder="请输入"
                v-model="cumulativeDelivery"
                size="small"
                type="number"
                style="width: 150px;"
                onKeypress="return(/^[0-9]*$/.test(String.fromCharCode(event.keyCode)))">
        <div slot="suffix"
             class="suffix">件</div>
      </el-input>
      <div style="width: 16px;"></div>
      <el-input placeholder="请输入"
                v-model="money"
                type="number"
                size="small"
                style="width: 150px;"
                onKeypress="return(/^[0-9]*$/.test(String.fromCharCode(event.keyCode)))">
        <div slot="suffix"
             class="suffix">元</div>
      </el-input>
      <div style="width: 16px;"></div>
      <el-button type="primary"
                 size="small"
                 @click="addCheck">添加供货</el-button>
    </div>

    <el-scrollbar style="height: calc(100vh - 205px);z-index: 1;"
                  width="100%">
      <div class="listView"
           style="position: sticky;top: 0px;background-color: #fff;z-index: 9999;">
        <div class="listProvince"
             style="position: sticky;left: 0px;z-index: 999;">
          <span>地区</span>
        </div>
        <div class="listCompany"
             style="z-index: 888;">
          <div class="lineView"
               style="z-index: 888;">
            <div style="width: 250px;position: sticky;left: 100px;background-color: #fff;z-index: 888;">合作医药公司</div>
            <!-- <div style="width: 150px;z-index: 777;">ERP对接状态</div> -->
            <div style="width: 150px;z-index: 777;">剩余库存（件）</div>
            <div style="width: 150px;z-index: 777;">累计发货（件）</div>
            <div style="width: 150px;z-index: 777;">应收金额 (元)</div>
            <div style="width: 100px;z-index: 777;">1月</div>
            <div style="width: 100px;z-index: 777;">2月</div>
            <div style="width: 100px;z-index: 777;">3月</div>
            <div style="width: 100px;z-index: 777;">4月</div>
            <div style="width: 100px;z-index: 777;">5月</div>
            <div style="width: 100px;z-index: 777;">6月</div>
            <div style="width: 100px;z-index: 777;">7月</div>
            <div style="width: 100px;z-index: 777;">8月</div>
            <div style="width: 100px;z-index: 777;">9月</div>
            <div style="width: 100px;z-index: 777;">10月</div>
            <div style="width: 100px;z-index: 777;">11月</div>
            <div style="width: 100px;z-index: 777;">12月</div>
          </div>
        </div>
      </div>
      <div class="listView"
           v-for="item, index in list"
           :key="index">
        <div class="listProvince"
             style="position: sticky;left: 0px;background-color: #fff;"
             :style="{height:item.statisticalDetailsList.length ? item.statisticalDetailsList.length * 60 +'px' : '60px'}">
          <span>{{ item.cityName }}</span>
        </div>
        <div class="listCompany">
          <div v-for="inner, innerIndex in item.statisticalDetailsList"
               :key="inner.shopId">
            <div class="lineView"
                 @click="lineClick(index,innerIndex)">
              <div style="position: sticky;left: 100px;background-color: #fff;"
                   class="name">
                <el-tag v-if="inner.shopName !='全国'"
                        size="mini"
                        :type="inner.erpToolStatus == 'normal' ? 'success': inner.erpToolStatus == 'unconnect' ? 'info':inner.erpToolStatus == 'disconnected' ? 'danger': 'info'"
                        effect="dark">
                  {{ inner.erpToolStatus == 'normal' ? `正&nbsp;&nbsp;&nbsp;常`: inner.erpToolStatus == 'unconnect' ? '未对接':inner.erpToolStatus == 'disconnected' ? '已断开': '未对接' }}
                </el-tag>
                <span style="margin-left:10px"> {{ inner.shopName}}</span>

              </div>
              <!-- <div>{{  inner.erpToolStatus == 'normal' ? '正常': inner.erpToolStatus == 'unconnect' ? '未对接':inner.erpToolStatus == 'disconnected' ? '已断开': '' }}</div> -->
              <div>{{  countSurplusStock(inner.surplusStock)}}</div>
              <div>
                {{ inner.cumulativeDelivery || 0 }}
                <i class="el-icon-arrow-down"
                   v-show="!inner.expand"></i>
                <i class="el-icon-arrow-up"
                   v-show="inner.expand"></i>
              </div>
              <div>{{ inner.amountReceivable ? inner.amountReceivable.toFixed(2) : '0.00' }}</div>
              <div class="monthClass">{{inner.januaryAccumulatedAmount || ''}}</div>
              <div class="monthClass">{{inner.februaryAccumulatedAmount || ''}}</div>
              <div class="monthClass">{{inner.marchAccumulatedAmount || ''}}</div>
              <div class="monthClass">{{inner.aprilAccumulatedAmount || ''}}</div>
              <div class="monthClass">{{inner.mayAccumulatedAmount || ''}}</div>
              <div class="monthClass">{{inner.juneAccumulatedAmount || ''}}</div>
              <div class="monthClass">{{inner.julyAccumulatedAmount || ''}}</div>
              <div class="monthClass">{{inner.augustAccumulatedAmount || ''}}</div>
              <div class="monthClass">{{inner.septemberAccumulatedAmount || ''}}</div>
              <div class="monthClass">{{inner.octAccumulatedAmount || ''}}</div>
              <div class="monthClass">{{inner.novemberAccumulatedAmount || ''}}</div>
              <div class="monthClass">{{inner.decAccumulatedAmount || ''}}</div>
            </div>
            <div class="lineBottom"
                 v-show="inner.expand">
              <div v-for="detail,index in inner.list"
                   class="historyList"
                   :key="index">
                <span>{{detail.purchaseTime || ''}}</span>
                <span style="margin: 0px 10px;"> {{detail.cumulativeDelivery || ''}}</span>
                <span style="margin-right: 10px;">件</span>
                <span>{{showMoney(detail.amountReceivable)}}</span>
                <el-button type="text"
                           @click="deleteInfo(detail)"
                           style="margin-left: 16px;">删除</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-scrollbar>
    <el-dialog :visible.async="showDialog"
               title="新增提醒"
               :before-close="handleCloseDialog"
               width="30%">
      <div class="timeText">{{ getTime(timeSelect) }}</div>
      <div class="supplyView">向 <span>{{ supplyPerson?.shopName }}</span>供货 <span>{{ goodsType }}</span> </div>
      <div class="priceView"><span>{{ cumulativeDelivery }}</span>件<span>{{ showMoney(money) }}</span>元</div>
      <div class="buttonArrView">
        <el-button type="default"
                   plain
                   size="small"
                   @click="handleCloseDialog">取消</el-button>
        <el-button type="primary"
                   size="small"
                   @click="addSupply">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import dayjs from 'dayjs'
import { queryApplicationStatisticsList, updateApplicationStatistics, queryApplicationStatisticsByOrgCodeOrShopId, deleteApplicationStatisticsById } from "@/api/statistics";
export default {
  data () {
    return {
      timeSelect: '',
      goodsType: "消肿止痛贴",
      cumulativeDelivery: '',
      money: '',
      list: [],
      companyList: [],
      state: '',
      showDialog: false,
      supplyPerson: null,
      tableHeight: 450,
    }
  },
  mounted () {
    this.queryList()
    this.$nextTick(() => {
      let height = window.innerHeight;
      this.tableHeight = height;
    })
  },
  methods: {
    countSurplusStock (v) {
      // 计算剩余库存
      if (!v) {
        return 0
      }
      return parseInt(v)
    },
    async queryList () {
      const resp = await queryApplicationStatisticsList({});
      if (resp && resp.data && resp.data.length) {
        if (!this.companyList.length) {
          let tmp = []
          resp.data.forEach((e) => {
            if (e.statisticalDetailsList && e.statisticalDetailsList.length) {
              e.statisticalDetailsList.forEach((l) => {
                l['cityName'] = e.cityName
                l['expand'] = false
                l['orgCode'] = e.orgCode
                tmp.push(l)
              })
              // this.companyList  = this.companyList.concat(e.statisticalDetailsList)
            }
          })
          this.companyList = tmp
        }
        let allArea = {
          cityName: '全国',
          orgCode: '',
          statisticalDetailsList: []
        }
        let statisticalDetailsListData = {
          shopName: '全国',
          erpToolStatus: '', // 链接状态
          surplusStock: 0,//剩余库存
          cumulativeDelivery: 0,//累计发货
          amountReceivable: 0,//应收金额
          januaryAccumulatedAmount: 0,
          februaryAccumulatedAmount: 0,
          marchAccumulatedAmount: 0,
          aprilAccumulatedAmount: 0,
          mayAccumulatedAmount: 0,
          juneAccumulatedAmount: 0,
          julyAccumulatedAmount: 0,
          augustAccumulatedAmount: 0,
          septemberAccumulatedAmount: 0,
          octAccumulatedAmount: 0,
          novemberAccumulatedAmount: 0,
          decAccumulatedAmount: 0,
        }
        resp.data.forEach((e) => {
          if (e.statisticalDetailsList && e.statisticalDetailsList.length) {
            e.statisticalDetailsList.forEach((l) => {
              statisticalDetailsListData.surplusStock += this.countSurplusStock(l.surplusStock)
              statisticalDetailsListData.cumulativeDelivery += l.cumulativeDelivery
              statisticalDetailsListData.amountReceivable += l.amountReceivable

              statisticalDetailsListData.januaryAccumulatedAmount += l.januaryAccumulatedAmount
              statisticalDetailsListData.februaryAccumulatedAmount += l.februaryAccumulatedAmount
              statisticalDetailsListData.marchAccumulatedAmount += l.marchAccumulatedAmount
              statisticalDetailsListData.aprilAccumulatedAmount += l.aprilAccumulatedAmount
              statisticalDetailsListData.mayAccumulatedAmount += l.mayAccumulatedAmount
              statisticalDetailsListData.juneAccumulatedAmount += l.juneAccumulatedAmount
              statisticalDetailsListData.julyAccumulatedAmount += l.julyAccumulatedAmount
              statisticalDetailsListData.augustAccumulatedAmount += l.augustAccumulatedAmount
              statisticalDetailsListData.septemberAccumulatedAmount += l.septemberAccumulatedAmount
              statisticalDetailsListData.octAccumulatedAmount += l.octAccumulatedAmount
              statisticalDetailsListData.novemberAccumulatedAmount += l.novemberAccumulatedAmount
              statisticalDetailsListData.decAccumulatedAmount += l.decAccumulatedAmount
            })
          }
        })
        allArea.statisticalDetailsList.push(statisticalDetailsListData)
        resp.data.unshift(allArea)
        this.list = resp.data

      }
    },
    async save (section, row) {
      let updateObj = {
        orgCode: this.supplyPerson.orgCode,
        shopId: this.supplyPerson.shopId,
        cumulativeDelivery: this.cumulativeDelivery,
        purchaseTime: dayjs(this.timeSelect).format('YYYY-MM-DD'),
        purchaseAmount: this.money
      }
      // this.list.forEach((e, index) => {
      //     if (section == index) {
      //         e.statisticalDetailsList.forEach((l, innerIndex) => {
      //             if (row == innerIndex) {
      //                 updateObj.orgCode = e.orgCode
      //                 updateObj.shopId = l.shopId
      //                 updateObj.cumulativeDelivery = l.cumulativeDelivery
      //             }
      //         })
      //     }
      // })
      // if (!updateObj.cumulativeDelivery) {
      //     return
      // }
      const resp = await updateApplicationStatistics(updateObj)
      if (resp.success) {
        this.showDialog = false
        this.$message.success('新增成功')
        this.queryList()
      }

    },
    getYear () {
      return dayjs().year()
    },
    handleCloseDialog () {
      this.showDialog = false;
    },
    showMoney (m = 0) {
      if (!m) {
        return ''
      }
      return parseFloat(m).toFixed(2)
    },
    getTime (time) {
      if (!time) {
        return ''
      }
      return dayjs(this.timeSelect).format('YYYY年MM月DD日');
    },
    querySearch (queryString, cb) {
      var companyList = this.companyList;
      var results = queryString ? companyList.filter(this.createFilter(queryString)) : companyList;
      cb(results);
    },
    createFilter (queryString) {
      return (companyList) => {
        return (companyList.shopName.indexOf(queryString) > -1);
      };
    },
    handleSelect (item) {
      this.state = item.shopName;
      this.supplyPerson = item;
    },
    addCheck () {
      if (!this.supplyPerson) {
        this.$message.warning('请选择医药公司')
        return
      }
      if (!this.timeSelect) {
        this.$message.warning('请选择日期')
        return
      }
      if (!this.cumulativeDelivery) {
        this.$message.warning('请输入供货件数')
        return
      }
      if (!this.money) {
        this.$message.warning('请输入供货价格')
        return
      }
      this.showDialog = true
    },
    addSupply () {
      this.save()

    },
    async lineClick (section, row) {
      let newData = { ...this.list }
      let sectionData = newData[section]
      if (sectionData.statisticalDetailsList && sectionData.statisticalDetailsList.length) {
        let rowData = sectionData.statisticalDetailsList[row];
        if (rowData.expand) {
          rowData.expand = !rowData.expand;
          this.list = newData
        } else {
          let obj = {
            orgCode: sectionData.orgCode,
            shopId: rowData.shopId
          }
          const resp = await queryApplicationStatisticsByOrgCodeOrShopId(obj)
          if (resp && resp.data) {
            rowData['list'] = resp.data
            rowData.expand = !rowData.expand;
            this.list = newData
          }
        }
      }
    },
    deleteInfo (e) {

      if (!e.id) {
        return
      }
      try {
        const resp = deleteApplicationStatisticsById(e.id)
        if (resp) {
          setTimeout(() => {
            this.queryList()
          }, 100);
        }
      } catch (error) {

      }

    }
    // objectSpanMethod({ row, column, rowIndex, columnIndex }) {
    //     const dataProvider = this.companyList;
    //     if (columnIndex === 0) {
    //         const prevRow = dataProvider[rowIndex - 1]; //上一条数据
    //         let nextRow = dataProvider[rowIndex + 1]; //下一条数据
    //         // 如果上一条数据存在并且上一条数据和当前数据相同，那么就不渲染这个单元格
    //         if (prevRow && prevRow.cityName === row.cityName) {
    //             return { rowspan: 0, colspan: 0 };
    //             //不相同判断如何渲染
    //         } else {
    //             let rowspan = 1;
    //             // 如果下一条数据和当前数据相同那么应该合并单元格 while判断下边有几行和当前数据相同，while直到找到不相同的退出循环
    //             while (nextRow && nextRow.cityName === row.cityName) {
    //                 rowspan++;
    //                 // 只要当前行和下一行相同，那么对比rowspan加下一条数据是否相同
    //                 nextRow = dataProvider[rowspan + rowIndex];
    //             }
    //             if (rowspan > 1) {
    //                 return { rowspan, colspan: 1 };
    //             }
    //         }
    //     }
    // }
  }
}
</script>
<style lang="scss" scoped>
.main {
  background-color: #fff;
  padding: 16px;
  border-radius: 4px;
  z-index: 99999;
  .addView {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    z-index: 99999;
    .suffix {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }

    .my-autocomplete {
      z-index: 88888;
      li {
        line-height: normal;
        padding: 7px;

        .name {
          text-overflow: ellipsis;
          overflow: hidden;
        }

        .addr {
          font-size: 12px;
          color: #b4b4b4;
        }

        .highlighted .addr {
          color: #ddd;
        }
      }
    }
  }

  .topView {
    display: flex;
    flex: 1;
    align-items: center;
    height: 50px;
    color: #666;
    border-bottom: 1px solid #eee;
    .month {
      width: 100px;
    }
  }

  .listView {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex: 1;
    .listProvince {
      display: flex;
      background-color: #fff;
      width: 100px;
      align-items: center;
      span {
        font-size: 16px;
        color: #262626;
        font-weight: 600;
        width: 100px;
      }
    }

    .listCompany {
      display: flex;
      flex-direction: column;
      flex: 1;
      font-size: 16px;
      color: #595959;
      min-height: 60px;
      .lineView {
        height: 60px;
        display: flex;
        align-items: center;
        flex: 1;
        background-color: #fff;
        border-bottom: 1px solid #eee;
        .name {
          padding-right: 10px;
          width: 250px;
          display: flex;
          align-items: center;
        }

        div {
          width: 150px;
        }
        .monthClass {
          // display: flex;
          // flex: 1;
          width: 100px;
          z-index: 555;
        }
      }
    }
  }

  .timeText {
    font-size: 18px;
    color: #595959;
    margin: 16px 0px;
  }

  .supplyView {
    display: flex;
    align-items: center;
    margin: 24px 0px;

    span {
      color: #262626;
      font-weight: 600;
      font-size: 18px;
      margin: 0px 10px;
    }
  }

  .priceView {
    display: flex;
    align-items: center;
    margin: 24px 0px;
    justify-content: center;

    span {
      color: var(--main-color);
      font-weight: 600;
      font-size: 22px;
      margin: 0px 10px;
    }
  }

  .buttonArrView {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .lineBottom {
    background-color: #fafafa;
  }
  .historyList {
    margin-left: 400px;
    display: flex;
    align-items: center;
    height: 30px;
    span {
      font-size: 14px;
      color: #595959;
    }
  }
}
</style>